/// <amd-module name="Core/Medius.Core.Web/Scripts/AdminPages/Currency/General/general"/>
import {IEntityWithContext} from "Core/Medius.Core.Web/Scripts/AdminPages/IEntityWithContext";

export default function create(entityWithContext: IEntityWithContext, _companyContextId: number, _tabModel: any){
    return entityWithContext.Entity;
}
